import { adaptV4Theme, createTheme, responsiveFontSizes } from '@mui/material/styles';
import overrides from './overrides';

import palette from './palette';
import typography from './typographyAdmin';

// Create theme using new API
let theme = createTheme(adaptV4Theme({
  palette,
  typography,
  components: overrides, // ✅ replaced "overrides" with "components" in MUI v5
}));

// Make font sizes responsive
theme = responsiveFontSizes(theme);

export default theme;
